import { Box, Flex, Text, Skeleton } from '@chakra-ui/react';

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchOrganization, fetchOrganizationJournals } from 'src/api/queries';
import { Layout } from 'src/components/Layout';
import SubmissionCard, {
  SubmissionCardLoader
} from 'src/components/SubmissionCard';
import NotFound from 'src/pages/Status/NotFound';
import { Image } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-regular-svg-icons';

const OrganizationProfile = () => {
  const { shortname = '' } = useParams();
  const { data: journals, isLoading } = useQuery({
    queryKey: ['organization-journals', { shortname }],
    queryFn: () => fetchOrganizationJournals(shortname),
    retry: 0
  });

  const { data: organization, isLoading: isLoadingOrg } = useQuery({
    queryKey: [`organization-${shortname}`],
    queryFn: () => fetchOrganization(shortname),
    retry: 0
  });

  if (!organization && !isLoadingOrg) return <NotFound />;

  return (
    <Layout width="960px">
      <Flex flexDirection="column" gap={4} alignItems="flex-start">
        <Box width={16} height={16}>
          {isLoadingOrg ? (
            <Skeleton width={16} height={16} />
          ) : organization?.media?.logo ? (
            <Image src={organization?.media?.logo} />
          ) : (
            <FontAwesomeIcon
              icon={faImage}
              size="6x"
              height="100%"
              width="100%"
            />
          )}
        </Box>
        <Text textStyle="headingTitle">{organization?.name}</Text>
        <Text>{organization?.description}</Text>
        {!isLoadingOrg ? (
          <Text textStyle="headingGroup">
            <Text as="span" textTransform="uppercase">
              {organization?.shortname}
            </Text>
            's Journals
          </Text>
        ) : null}
        <Flex flexDirection="column" gap={4} width="100%">
          {isLoading ? (
            <SubmissionCardLoader length={4} />
          ) : journals?.collection.length ? (
            journals?.collection.map(journal => (
              <SubmissionCard
                key={journal.id}
                url={`/j/${journal.id}`}
                title={journal.data.name}
                keywords={[]}
              />
            ))
          ) : (
            'No Journals found'
          )}
        </Flex>
      </Flex>
    </Layout>
  );
};

export default OrganizationProfile;
